/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --max-width: 100%;
  display: block;
  min-width: fit-content;
}

:host([border]) {
  --node-border: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
}

[internal-host] {
  max-width: var(--max-width);
  min-width: fit-content;
}
